import { useMemo, useState } from "react";

import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import {
  buildAssemblyChildIdsByParentId,
  getIndeterminateRowIds,
  syncAssemblySelection,
} from "#modules/quoteRequestLinesV2/domain/syncAssemblySelection";
import { isPartBeingAnalyzed } from "shared";

export const useQuoteRequestLinesSelection = (quoteRequestLines: QuoteRequestLineDto[]) => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const childIdsByParentId = useMemo(
    () => buildAssemblyChildIdsByParentId(quoteRequestLines),
    [quoteRequestLines],
  );

  const rowSelection = useMemo(
    () => Object.fromEntries(selectedIds.map((id) => [id, true])),
    [selectedIds],
  );

  const indeterminateRowIds = useMemo(
    () => getIndeterminateRowIds(selectedIds, childIdsByParentId),
    [childIdsByParentId, selectedIds],
  );

  const selectedLines = useMemo(
    () => quoteRequestLines.filter((line) => rowSelection[line.id]),
    [quoteRequestLines, rowSelection],
  );

  const handleRowSelectionChange = (nextSelectedIds: string[]) => {
    setSelectedIds((previousSelectedIds) =>
      syncAssemblySelection({ previousSelectedIds, nextSelectedIds, childIdsByParentId }),
    );
  };

  return {
    selectedCount: selectedLines.length,
    hasAnalyzingSelectedLine: selectedLines.some((line) => isPartBeingAnalyzed(line.part)),
    rowSelection,
    indeterminateRowIds,
    handleRowSelectionChange,
    clearSelection: () => setSelectedIds([]),
    selectedIds,
  };
};
